import { Filter } from '@fabric-ui/components';
import {
  filterToSqlConverter,
  mergeOr,
  SqlToFilterConverter,
  SqlToFilterConverterColumnType,
  type FilterToSqlOptions,
  type SqlToFilterConverterColumnSchema,
} from '../../utils/filter';
import { field } from '../../utils/filter/filter-builder';
import { conditionBuilderFactory, makeNullCondition } from '../../utils/filter/SqlToFilterConverter/condition-builder';
import { LogsPieSliceSelection } from './types';

const createStatement = (table: string, where: string) => `SELECT * FROM "${table}" WHERE ${where}`;
const createParser = (columnRef: SqlToFilterConverterColumnSchema, options?: { preserveGroups?: boolean }) =>
  SqlToFilterConverter.create(columnRef, options);
const extractWhereStatement = (sql: string) => sql.split('WHERE')[1]?.trim() || '';

type PreserveGroupsOption = Pick<FilterToSqlOptions, 'preserveGroups'>;

export const parseLogsQuery = (columnRef: SqlToFilterConverterColumnSchema, table: string, sql: string, options?: PreserveGroupsOption) => {
  if (sql && table) {
    try {
      const statement = createStatement(table, sql);
      return createParser(columnRef, options).parse(statement);
    } catch {
      return null;
    }
  }
  return null;
};

export function filterToWhereSql(newFilter: Filter, table: string, options?: PreserveGroupsOption) {
  const query = filterToSqlConverter(newFilter, table, options);
  const where = extractWhereStatement(query);
  return where;
}

type CreateSearchExpressionFn = (
  key: string,
  value: string | number | boolean | null,
  columnType?: SqlToFilterConverterColumnType
) => Filter;

export const createAddToSearchExpression: CreateSearchExpressionFn = (key, value, columnType = 'string') => {
  if (value === null) {
    return makeNullCondition(key, columnType, 'IS');
  }
  // @ts-expect-error: @nizans fixme -- value type
  return conditionBuilderFactory(columnType)(key, '=', value);
};

export const createExcludeFromSearchExpression: CreateSearchExpressionFn = (key, value, columnType = 'string') => {
  if (value === null) {
    return makeNullCondition(key, columnType, 'IS NOT');
  }
  // @ts-expect-error: @nizans fixme -- value type
  return conditionBuilderFactory(columnType)(key, '!=', value);
};

export const createPieFilter = (value: LogsPieSliceSelection[], fieldName: string, colType: SqlToFilterConverterColumnType) => {
  if (value.length === 0) return null;
  const values = value.map(v => (Array.isArray(v.value) ? v.value[0] : v.value));
  const filter = mergeOr(...values.map(v => createAddToSearchExpression(fieldName, v, colType)));
  return filter;
};

export const prepareDateFilter = (date: Date[], isFirstParty: boolean, table: string) =>
  field(isFirstParty ? `${table}.event_timestamp` : 'time').date.between(date[0], date[1]);
